export default __webpack_public_path__ + "static/media/letter-c.f1407aee.svg";